import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest, sendBulkApiRequest } from 'utils/api'
import { getClientId } from 'utils/utils'

export const GET_UTILITY_REQUEST_COUNT = 'GET_UTILITY_REQUEST_COUNT'
export const getUtilityRequestCount = (search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_UTILITY_REQUEST_COUNT)())
    const clientId = getClientId(getState)
    const options = {
      where: {
        and: [
          { utilityClientId: clientId }
        ]
      }
    }
    if (search) {
      options.where.and.push(search)
    }
    sendApiRequest('UtilityRequests/count', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getUtilityRequestCountError(response))
      }
      if (response.status === 'success') {
        dispatch(getUtilityRequestCountSuccess(response.data.count))
      }
    })
  }
}

export const GET_UTILITY_REQUEST_COUNT_SUCCESS = 'GET_UTILITY_REQUEST_COUNT_SUCCESS'
export const getUtilityRequestCountSuccess = createAction(GET_UTILITY_REQUEST_COUNT_SUCCESS)

export const GET_UTILITY_REQUEST_COUNT_ERROR = 'GET_UTILITY_REQUEST_COUNT_ERROR'
export const getUtilityRequestCountError = createAction(GET_UTILITY_REQUEST_COUNT_ERROR)

export const GET_UTILITY_REQUESTS = 'GET_UTILITY_REQUESTS'
export const getUtilityRequests = (pageSize, pageNumber, search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_UTILITY_REQUESTS)())
    const clientId = getClientId(getState)
    const options = {
      filter: {
        order: 'utilityId DESC',
        where: {
          and: [
            { utilityClientId: clientId }
          ]
        }
      }
    }
    if (pageSize !== 0) {
      options.filter.limit = pageSize + 1
    }
    if (pageNumber !== 1) {
      options.filter.skip = (pageNumber - 1) * pageSize
    }
    if (search) {
      options.filter.where.and.push(search)
    }
    sendApiRequest('UtilityRequests', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getUtilityRequestsError(response))
      }
      if (response.status === 'success') {
        dispatch(getUtilityRequestsSuccess(response.data))
      }
    })
  }
}

export const GET_UTILITY_REQUESTS_SUCCESS = 'GET_UTILITY_REQUESTS_SUCCESS'
export const getUtilityRequestsSuccess = createAction(GET_UTILITY_REQUESTS_SUCCESS)

export const GET_UTILITY_REQUESTS_ERROR = 'GET_UTILITY_REQUESTS_ERROR'
export const getUtilityRequestsError = createAction(GET_UTILITY_REQUESTS_ERROR)

export const GET_UTILITY_REQUEST_BY_ID = 'GET_UTILITY_REQUEST_BY_ID'
export const getUtilityRequestById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_UTILITY_REQUEST_BY_ID)())
    sendApiRequest(`UtilityRequests/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'get').then((response) => {
      if (response.status === 'failure') {
        dispatch(getUtilityRequestByIdError(response))
      }
      if (response.status === 'success') {
        dispatch(getUtilityRequestByIdSuccess(response.data))
      }
    })
  }
}

export const GET_UTILITY_REQUEST_BY_ID_SUCCESS = 'GET_UTILITY_REQUEST_BY_ID_SUCCESS'
export const getUtilityRequestByIdSuccess = createAction(GET_UTILITY_REQUEST_BY_ID_SUCCESS)

export const GET_UTILITY_REQUEST_BY_ID_ERROR = 'GET_UTILITY_REQUEST_BY_ID_ERROR'
export const getUtilityRequestByIdError = createAction(GET_UTILITY_REQUEST_BY_ID_ERROR)

export const GET_UTILITY_REQUEST_BY_ID_RESET = 'GET_UTILITY_REQUEST_BY_ID_RESET'
export const getUtilityRequestByIdReset = createAction(GET_UTILITY_REQUEST_BY_ID_RESET)

export const DELETE_UTILITY_REQUEST_BY_ID = 'DELETE_UTILITY_REQUEST_BY_ID'
export const deleteUtilityRequestById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_UTILITY_REQUEST_BY_ID)())
    sendApiRequest(`UtilityRequests/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'delete').then((response) => {
      if (response.status === 'failure') {
        dispatch(deleteUtilityRequestByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(deleteUtilityRequestByIdSuccess(response.data))
      }
    })
  }
}

export const DELETE_UTILITY_REQUEST_BY_ID_SUCCESS = 'DELETE_UTILITY_REQUEST_BY_ID_SUCCESS'
export const deleteUtilityRequestByIdSuccess = createAction(DELETE_UTILITY_REQUEST_BY_ID_SUCCESS)

export const DELETE_UTILITY_REQUEST_BY_ID_ERROR = 'DELETE_UTILITY_REQUEST_BY_ID_ERROR'
export const deleteUtilityRequestByIdError = createAction(DELETE_UTILITY_REQUEST_BY_ID_ERROR)

export const DELETE_UTILITY_REQUEST_BY_ID_RESET = 'DELETE_UTILITY_REQUEST_BY_ID_RESET'
export const deleteUtilityRequestByIdReset = createAction(DELETE_UTILITY_REQUEST_BY_ID_RESET)

export const BULK_CREATE_UTILITY_REQUEST = 'BULK_CREATE_UTILITY_REQUEST'
export const bulkCreateUtilityRequest = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(BULK_CREATE_UTILITY_REQUEST))
    const utilityData = []
    data.forEach((item) => {
      if (item.utility_req_id) {
        const clientId = getClientId(getState)
        const filteredItem = {
          utilityClientId: clientId,
          utilityReqId: parseInt(item.utility_req_id.replace(/,/g, '')),
          requester: item.requester,
          descOfDrawing: item.desc_of_drawing,
          noOfCopies: item.no_of_copies,
          reqDate: item.req_date
        }
        utilityData.push(filteredItem)
      }
    })
    const dataToSend = {
      accessToken: getState().auth.account.accessToken,
      array: utilityData
    }
    sendBulkApiRequest('UtilityRequests', dataToSend, 'post').then((response) => {
      if (response.status === 'failure') {
        dispatch(bulkCreateUtilityRequestError(response.data))
      }
      if (response.status === 'success') {
        dispatch(bulkCreateUtilityRequestSuccess(response.data))
      }
    })
  }
}

export const BULK_CREATE_UTILITY_REQUEST_SUCCESS = 'BULK_CREATE_UTILITY_REQUEST_SUCCESS'
export const bulkCreateUtilityRequestSuccess = createAction(BULK_CREATE_UTILITY_REQUEST_SUCCESS)

export const BULK_CREATE_UTILITY_REQUEST_ERROR = 'BULK_CREATE_UTILITY_REQUEST_ERROR'
export const bulkCreateUtilityRequestError = createAction(BULK_CREATE_UTILITY_REQUEST_ERROR)

const initialState = {
  utilityRequestCount: 0,
  isGettingUtilityRequests: false,
  hasGottenUtilityRequests: false,
  getUtilityRequestsError: {},
  utilityRequests: [],
  selectedUtilityRequest: {},
  isGettingUtilityRequest: false,
  hasGottenUtilityRequest: false,
  getUtilityRequestError: {},
  isDeletingUtilityRequest: false,
  hasDeletedUtilityRequest: false,
  deleteUtilityRequestSuccess: {},
  deleteUtilityRequestError: {},
  isCreatingUtilityRequests: false,
  hasCreatedUtilityRequests: false,
  createUtilityRequestsError: [],
  createUtilityRequestsSuccess: []
}

export default handleActions({

  [GET_UTILITY_REQUEST_COUNT_SUCCESS]: (state, { payload }) => ({
    ...state,
    utilityRequestCount: payload
  }),

  [GET_UTILITY_REQUESTS]: (state) => ({
    ...state,
    isGettingUtilityRequests: true,
    hasGottenUtilityRequests: false
  }),

  [GET_UTILITY_REQUESTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingUtilityRequests: false,
      hasGottenUtilityRequests: true,
      utilityRequests: payload
    }
  },

  [GET_UTILITY_REQUESTS_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingUtilityRequests: false,
      hasGottenUtilityRequests: false,
      utilityRequestsError: payload
    }
  },

  [GET_UTILITY_REQUEST_BY_ID]: (state) => ({
    ...state,
    isGettingUtilityRequest: true,
    hasGottenUtilityRequest: false
  }),

  [GET_UTILITY_REQUEST_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingUtilityRequest: false,
      hasGottenUtilityRequest: true,
      selectedUtilityRequest: payload
    }
  },

  [GET_UTILITY_REQUEST_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingUtilityRequest: false,
      hasGottenUtilityRequest: false,
      getUtilityRequestError: payload
    }
  },
  [GET_UTILITY_REQUEST_BY_ID_RESET]: (state) => ({
    ...state,
    isGettingUtilityRequest: false,
    hasGottenUtilityRequest: false,
    selectedUtilityRequest: {}
  }),

  [DELETE_UTILITY_REQUEST_BY_ID]: (state) => ({
    ...state,
    isDeletingUtilityRequest: true,
    hasDeletedUtilityRequest: false
  }),

  [DELETE_UTILITY_REQUEST_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isDeletingUtilityRequest: false,
      hasDeletedUtilityRequest: true,
      deleteUtilityRequestSuccess: payload
    }
  },

  [DELETE_UTILITY_REQUEST_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isDeletingUtilityRequest: false,
      hasDeletedUtilityRequest: false,
      deleteUtilityRequestError: payload
    }
  },

  [DELETE_UTILITY_REQUEST_BY_ID_RESET]: (state) => {
    return {
      ...state,
      isDeletingUtilityRequest: false,
      hasDeletedUtilityRequest: false,
      deleteUtilityRequestError: {},
      deleteUtilityRequestSuccess: {}
    }
  },

  [BULK_CREATE_UTILITY_REQUEST]: (state) => {
    return {
      ...state,
      isCreatingUtilityRequests: true,
      hasCreatedUtilityRequests: false,
      createUtilityRequestsError: [],
      createUtilityRequestsSuccess: []
    }
  },

  [BULK_CREATE_UTILITY_REQUEST_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isCreatingUtilityRequests: false,
      hasCreatedUtilityRequests: true,
      createUtilityRequestsError: [],
      createUtilityRequestsSuccess: payload
    }
  },

  [BULK_CREATE_UTILITY_REQUEST_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isCreatingUtilityRequests: false,
      hasCreatedUtilityRequests: false,
      createUtilityRequestsError: payload,
      createUtilityRequestsSuccess: []
    }
  }

}, initialState)
